import { useEffect, useContext } from 'react';
import { LoginStateConext } from "../context/AuthContext";
import { TitleParamContext } from "../context/TitleContext";
import { PaymentPageType, NewProductParam } from "../common/Types";
import { Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom'
import { TitleDiv, CenterBox, OnsiteButton, MainContentsBox } from "../customelements/CustomInput";
import { JumpPage } from '../common/Util';


export function Main() {

    const ctx = useContext(TitleParamContext);
    const navigate = useNavigate();

    useEffect(() => {
        ctx.setParamData({ mainTitle: "サポート・製品購入", firstSubTitle: "", secondSubTitle: "" });
    }, []);

    return (
        <LoginStateConext.Consumer>
            {
                value => {
                    if (value.isLogin) {
                        return (
                            <>
                                <MainContentsBox>
                                    <Grid container spacing={3} alignItems="stretch" justifyContent="center" direction="column">
                                        <Grid item xs={2}>
                                            <TitleDiv title="サポート" contents="（使用方法のお問い合わせ、ユーザ情報（パスワード等）の変更、ライセンスコードの確認、領収書の発行）" />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <CenterBox>
                                                <div style={{ marginTop: 5, marginBottom: 5 }}>
                                                    <OnsiteButton color="primary" variant="contained"
                                                        onClick={(e) => { JumpPage("/MyPage", {}, "", navigate) }}
                                                    >マイページ</OnsiteButton>
                                                </div>
                                            </CenterBox>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <TitleDiv title="製品購入" contents="" />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <CenterBox>
                                                <OnsiteButton color="primary" variant="contained"
                                                    onClick={(e) => { JumpPage<NewProductParam>("/MyPage/NewLicense", { categoryCode: "01", productCode: "01", paymentPageType: PaymentPageType.New, lisenceKey: "" }, "", navigate) }}
                                                >
                                                    新規ライセンス購入　＞</OnsiteButton>
                                            </CenterBox>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <CenterBox>
                                                <OnsiteButton color="primary" variant="contained"
                                                    onClick={(e) => { JumpPage<NewProductParam>("/MyPage/ContinueLicense", { categoryCode: "01", productCode: "01", paymentPageType: PaymentPageType.Continue, lisenceKey: "" }, "", navigate) }}
                                                >
                                                    Clicker Ace<br />
                                                    継続ライセンス購入　＞<br />
                                                    （保有ライセンスの有効期間の延長）
                                                </OnsiteButton>
                                            </CenterBox>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <CenterBox>
                                                <OnsiteButton color="primary" variant="contained"
                                                    onClick={(e) => { JumpPage<NewProductParam>("/MyPage/NewLicense", { categoryCode: "01", productCode: "01", paymentPageType: PaymentPageType.Pccase, lisenceKey: "" }, "", navigate) }}
                                                >
                                                    RPA端末用ケース (※1) 購入　＞<br />
                                                    （ Clicker Ace 3ヶ月 新規ライセンス付属 ）
                                                </OnsiteButton>
                                            </CenterBox>
                                        </Grid>
                                    </Grid>
                                </MainContentsBox>
                            </>
                        )
                    } else {
                        return (
                            <>
                                <MainContentsBox>
                                    <Grid container spacing={3} alignItems="stretch" justifyContent="center" direction="column">
                                        <Grid item xs={2}>
                                            <TitleDiv title="サポート" contents="（使用方法のお問い合わせ、ユーザ情報（パスワード等）の変更、ライセンスコードの確認、領収書の発行）" />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <CenterBox>
                                                <div style={{ marginTop: 5, marginBottom: 5 }}>
                                                    <OnsiteButton color="primary" variant="contained"
                                                        onClick={(e) => { JumpPage("/MyPage", {}, "", navigate) }}
                                                    >マイページ</OnsiteButton>
                                                </div>
                                            </CenterBox>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <TitleDiv title="製品購入" contents="" />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <CenterBox>
                                                <OnsiteButton color="primary" variant="contained"
                                                    onClick={(e) => { JumpPage<NewProductParam>("/MyPage/NewLicense", { categoryCode: "01", productCode: "01", paymentPageType: PaymentPageType.New, lisenceKey: "" }, "", navigate) }}
                                                >
                                                    新規ライセンス購入　＞</OnsiteButton>
                                            </CenterBox>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <CenterBox>
                                                <OnsiteButton color="primary" variant="contained"
                                                    onClick={(e) => { JumpPage<NewProductParam>("/MyPage/ContinueLicense", { categoryCode: "01", productCode: "01", paymentPageType: PaymentPageType.Continue, lisenceKey: "" }, "", navigate) }}
                                                >
                                                    Clicker Ace<br />
                                                    継続ライセンス購入　＞<br />
                                                    （保有ライセンスの有効期間の延長）
                                                </OnsiteButton>
                                            </CenterBox>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <CenterBox>
                                                <OnsiteButton color="primary" variant="contained"
                                                    onClick={(e) => { JumpPage<NewProductParam>("/MyPage/NewLicense", { categoryCode: "01", productCode: "01", paymentPageType: PaymentPageType.Pccase, lisenceKey: "" }, "", navigate) }}
                                                >
                                                    RPA端末用ケース (※1) 購入　＞<br />
                                                    （ Clicker Ace 3ヶ月 新規ライセンス付属 ）
                                                </OnsiteButton>
                                            </CenterBox>
                                        </Grid>
                                    </Grid>
                                </MainContentsBox>
                            </>
                        );
                    }
                }
            }
        </LoginStateConext.Consumer>
    )
}

const styles = {
    header: {
        height: 100,
        background: "#ddd",
    },
    main: {
        height: 200,
    },
    footer: {
        height: 100,
        background: "#ddd",
    }
}